export const ON_CHANGE_TEXTAREA_SEND_MESSAGE = 'ON_CHANGE_INPUT_SEND_MESSAGE';
export const ON_CLICK_TEXTAREA_SEND_MESSAGE = 'ON_CLICK_TEXTAREA_SEND_MESSAGE';
export const ON_CHANGE_TEXTAREA_POST_TEXT = 'ON_CHANGE_TEXTAREA_POST_TEXT';
export const ON_CLICK_ADD_POST = 'ON_CLICK_ADD_POST';
export const CHANGE_FOLLOW_STATUS = 'CHANGE_FOLLOW_STATUS';
